import Modal from '@material-ui/core/Modal';
import { Dispatch, SetStateAction, createContext, useContext, useState } from 'react';

type ModalProps = {
  children: any;
}

type ModalContextProps = {
  openModal: Dispatch<SetStateAction<boolean>>;
  modalContent: Dispatch<SetStateAction<JSX.Element>>;
}

const ModalContext = createContext({} as ModalContextProps);

const ModalComponent = ({ children }: ModalProps) => {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState(<></>);

  const handleClose = () => setOpen(false);

  return (
    <ModalContext.Provider value={{ openModal: setOpen, modalContent: setContent }}>
      {children}
      <Modal
        open={open}
        onClose={handleClose}
      >
        {content}
      </Modal>
    </ModalContext.Provider>
  )
};

export default ModalComponent;

export const useModal = () => useContext(ModalContext);